<!--
 * @Author: your name
 * @Date: 2021-03-11 16:03:07
 * @LastEditTime: 2021-07-27 11:07:48
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \mooklook_phone\src\views\AOG.vue
-->

<template>
  <div class="AGO">
    <div class="aog_content" :style="{minHeight:height+'px'}" v-html="articleContent"></div>
    <Footer></Footer>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import $ from "jquery";
import Footer from "@/components/Footer";
import {getArticleList } from "@/api/api";
export default {
  components: {Footer},
  // 定义属性
  data() {
    return {
      height: 0,
      articleList:[],
      articleContent:"",
      isPhone: document.body.clientWidth < 920,
    };
  },
  // 计算属性，会监听依赖属性值随之变化
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    getUrl(URL) {
      let http = window.location.protocol === "http:" ? "https:" : "https:";
      //调用跨域API
      let realurl = http + "//cors.bridged.cc/" + URL;
      $.ajax({
        type: "get",
        url: realurl,
        success:  (response)=> {
          if (response) {
            let html = response;
            html = html.replace(/data-src/g, "src")
                            .replace('/)<[^<]*)*<\/script>/g', '')
                            .replace('/https/g', 'http');
                            this.src = html;
            this.$nextTick(function () {

            });
          }
        },
        error: function (err) {
          console.log(err);
          // alert("好像出错了...");
        },
      });
    },
     getArticleList(min = 1, max = 6) {
      let params = {
        articleTypeId: this.lange == "Ch"?47:49,
        pageIndex: min,
        pageSize: max,
      };
      getArticleList(params).then((res) => {
        this.articleList = res.data.data.data;
        this.articleContent =this.articleList.length>0?this.articleList[0].articleContent:"";
      });
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getArticleList()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let height = this.isPhone ? 233 : 427;
    this.height = window.screen.availHeight - height;
  },
};
</script>

<style lang='less' scoped>
.AOG{
  width:100%;
}
</style>
